import React from 'react';
import { View, TouchableWithoutFeedback, Text } from 'react-native';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import AddIcon from '../../../assets/images/rn/AddIcon';
import MinusIcon from '../../../assets/images/rn/MinusIcon';
export var QuantitySelector = function QuantitySelector(props) {
  var _props$count = props.count,
    count = _props$count === void 0 ? 1 : _props$count,
    _props$minCount = props.minCount,
    minCount = _props$minCount === void 0 ? 1 : _props$minCount,
    _props$maxCount = props.maxCount,
    maxCount = _props$maxCount === void 0 ? 1 : _props$maxCount,
    onChange = props.onChange,
    handleReduceDisable = props.handleReduceDisable,
    handleAddDisable = props.handleAddDisable;
  var handleReduce = function handleReduce() {
    if (count > minCount) {
      var res = count > minCount ? count - 1 : minCount;
      onChange(res);
    } else {
      handleReduceDisable();
    }
  };
  var handleAdd = function handleAdd() {
    if (count < maxCount) {
      var res = count + 1;
      onChange(res);
    } else {
      handleAddDisable();
    }
  };
  return /*#__PURE__*/React.createElement(TouchableWithoutFeedback, null, /*#__PURE__*/React.createElement(View, {
    style: styles.container
  }, /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
    onPress: handleReduce
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.buttonWrapper]
  }, /*#__PURE__*/React.createElement(MinusIcon, {
    disable: count === 1
  }))), /*#__PURE__*/React.createElement(View, {
    style: [styles.buttonWrapper, styles.text]
  }, /*#__PURE__*/React.createElement(Text, null, count)), /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
    onPress: handleAdd
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.buttonWrapper]
  }, /*#__PURE__*/React.createElement(AddIcon, {
    disable: count === maxCount
  })))));
};
var styles = CustomStyleSheet({
  container: {
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 1
  },
  buttonWrapper: {
    width: 30,
    height: 30,
    justifyContent: 'center',
    alignItems: 'center'
  },
  text: {
    width: 65,
    borderWidth: 0,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: '#ccc'
  }
});